import {COMMON, CONSTANT} from "../../common.js";

const MEMBER_TENANT = (function () {
    let modules = {};

    $(".show-password, .hide-password").on('click', function() {
        let passwordInput = $('#password');
        let type = passwordInput.attr('type') === 'password' ? 'text' : 'password';
        passwordInput.attr('type', type);

        if ($(this).hasClass('hide-password')) {
            $(this).parent().find(".show-password").show();
            $(this).parent().find(".hide-password").hide();
        } else {
            $(this).parent().find(".hide-password").show();
            $(this).parent().find(".show-password").hide();
        }
    });

    $(".show-password-confirm, .hide-password-confirm").on('click', function() {
        let passwordInput = $('#confirm-password');
        let type = passwordInput.attr('type') === 'password' ? 'text' : 'password';
        passwordInput.attr('type', type);

        if ($(this).hasClass('hide-password-confirm')) {
            $(this).parent().find(".show-password-confirm").show();
            $(this).parent().find(".hide-password-confirm").hide();
        } else {
            $(this).parent().find(".hide-password-confirm").show();
            $(this).parent().find(".show-password-confirm").hide();
        }
    });

    modules.callAjaxCheckValidationPersonTenant = function () {
        let data = $('#form-member-person-tenant').serializeArray();
        return COMMON.callApi(CONSTANT.URL_CHECK_VALIDATION_ENTERPRISE_REGISTER, 'POST', 'JSON', data)
            .then(res => {
                $.each(data, function (index, val) {
                    $(`.confirm-person-tenant #${val.name.replace(/_/g, "-")}`).empty().text(val.value);
                });
                // display license image just uploaded
                const licenseFile = $('#license-upload')[0].files[0];
                if (licenseFile) {
                    $('#license-preview-confirm').attr('src', URL.createObjectURL(licenseFile));
                } else {
                    $('#license-preview-confirm').attr('src', $('.img-default-license').val());
                }
                // display invoice number
                $('#invoice-number-confirm').text($('#invoice-number').val());
                $('.tenant-person-info').addClass('d-none');
                $('.confirm-person-tenant').removeClass('d-none');
            })
            .catch(err => {
                $('.person-info .error').empty();
                if (err.status === 422) {
                    modules.showError(err.responseJSON.errors.tenant_id, '.err-tenant-id', '#tenant_id');
                    modules.showError(err.responseJSON.errors.email, '.err-email', '#email');
                    modules.showError(err.responseJSON.errors.password, '.err-password', '#password');
                    modules.showError(err.responseJSON.errors.confirm_password, '.err-confirm-password', '#confirm-password');
                    modules.showError(err.responseJSON.errors.name, '.err-name', '#name');
                    modules.showError(err.responseJSON.errors.katakana_name, '.err-katakana-name', '#katakana-name');
                    modules.showError(err.responseJSON.errors.company_name, '.err-company-name', '#company-name');
                    modules.showError(err.responseJSON.errors.company_katakana_name, '.err-company-katakana-name', '#company-katakana-name');
                    modules.showError(err.responseJSON.errors.phone, '.err-phone', '#phone');
                    modules.showError(err.responseJSON.errors.address, '.err-address', '#address');
                    modules.showError(err.responseJSON.errors['g-recaptcha-response'], '.err-recaptcha', '#g-recaptcha-response');
                    modules.showError(err.responseJSON.errors.license_image, '.err-license-image', '#license-upload');
                    modules.focusError(err.responseJSON.errors);
                }
            });
    }

    modules.callAjaxCheckValidationUpdateEnterpriseMember = function () {
        let data = $('#form-enterprise-member').serializeArray();

        COMMON.callApi(CONSTANT.URL_CHECK_VALIDATION_ENTERPRISE_MEMBER_UPDATE, 'POST', 'JSON', data)
            .then(res => {
                $.each(data, function (index, val) {
                    $(`.confirm-tenant-member-info #${val.name.replace(/_/g, "-")}-confirm`).empty().text(val.value);
                });
                const licenseInput = $('#license-upload')[0];
                let licenseFile = null;
                if (licenseInput && licenseInput.files && licenseInput.files[0]) {
                    licenseFile = licenseInput.files[0];
                    $('#license-preview-confirm').attr('src', URL.createObjectURL(licenseFile));
                } else {
                    $('#license-preview-confirm').attr('src', $('#license-preview').attr('src'));
                }
                $('#invoice-number-confirm').text($('#invoice-number').val());
                $('.tenant-person-info').addClass('d-none');
                $('.confirm-tenant-member-info').removeClass('d-none');
            })
            .catch(err => {
                $('.person-info .error').empty();
                if (err.status === 422) {
                    modules.showError(err.responseJSON.errors.name, '.err-name', '#name');
                    modules.showError(err.responseJSON.errors.katakana_name, '.err-katakana-name', '#katakana-name');
                    modules.showError(err.responseJSON.errors.company_name, '.err-company-name', '#company-name');
                    modules.showError(err.responseJSON.errors.company_katakana_name, '.err-company-katakana-name', '#company-katakana-name');
                    modules.showError(err.responseJSON.errors.phone, '.err-phone', '#phone');
                    modules.showError(err.responseJSON.errors.address, '.err-address', '#address');
                    modules.showError(err.responseJSON.errors.license_image, '.err-license-image', '#license-upload');
                    modules.focusError(err.responseJSON.errors);
                }
            });
    }

    modules.showError = function (err, element, hover) {
        if (err) {
            $(hover).addClass('hover-error')
            $(element).empty().append(err.shift());
        } else {
            $(hover).removeClass('hover-error')
            $(element).empty().append('')
        }
    }

    modules.focusError = function (err) {
        if (err) {
            if (err.license_image) {
                const $preview = $('.preview-image-license:visible').first();
                if ($preview.length) {
                    const offset = $preview.offset().top;
                    $([document.documentElement, document.body]).animate({
                        scrollTop: offset - 80
                    }, 500);
                    $preview.trigger('focus');
                    return;
                }
            }
            const $firstError = $('.hover-error:visible').first();
            if ($firstError.length) {
                const offset = $firstError.offset().top;
                $([document.documentElement, document.body]).animate({
                    scrollTop: offset - 100
                }, 500);
                $firstError.trigger('focus');
            }
        }
    }

    function initImageUpload({
        uploadId,
        previewId,
        removeBtnClass,
        changeBtnClass,
        errorClass,
        defaultUrl,
        maxSize = 15 * 1024 * 1024,
        allowedExt = ["jpg", "jpeg", "png"],
        hasInputName
    }) {
        $(document).on('click', changeBtnClass, function () {
            $(uploadId).trigger('click');
        });

        $(document).on('change', uploadId, function () {
            const file = this.files[0];
            if (file) {
                const ext = file.name.split('.').pop().toLowerCase();
                if (!allowedExt.includes(ext)) {
                    $(previewId).attr('src', defaultUrl);
                    $(removeBtnClass).addClass('d-none');
                    $(errorClass).text('JPG・JPEG・PNG形式のみアップロード可能です');
                    $(this).val('');
                    if (hasInputName) $(hasInputName).val(0);
                    return;
                }
                if (file.size > maxSize) {
                    $(previewId).attr('src', defaultUrl);
                    $(removeBtnClass).addClass('d-none');
                    $(errorClass).text('ファイルは15MB以内のJPG・JPEG・PNGにしてください');
                    $(this).val('');
                    if (hasInputName) $(hasInputName).val(0);
                    return;
                }
                $(errorClass).text('');
                $(previewId).attr('src', URL.createObjectURL(file));
                $(removeBtnClass).removeClass('d-none');
                if (hasInputName) $(hasInputName).val(1);
            }
        });

        $(document).on('click', removeBtnClass, function () {
            $(previewId).attr('src', defaultUrl);
            $(uploadId).val('');
            $(this).addClass('d-none');
            if (hasInputName) $(hasInputName).val(0);
        });

        $(document).on('load change', previewId, function () {
            const src = $(this).attr('src');
            if (src && src !== defaultUrl) {
                $(removeBtnClass).removeClass('d-none');
            } else {
                $(removeBtnClass).addClass('d-none');
            }
        });
    }

    initImageUpload({
        uploadId: '#license-upload',
        previewId: '#license-preview',
        removeBtnClass: '.btn-remove-license',
        changeBtnClass: '.btn-change-license',
        errorClass: '.err-license-image',
        defaultUrl: $('.img-default-license').val(),
        hasInputName: 'input[name="has_license"]'
    });

    return modules;
})(window.jQuery, window, document);

window.onRecaptchaSuccess = COMMON.handleRecaptchaSuccess;

$(document).ready(function () {

    $(document).on('click', '.btn-create-member-tenant', function (event) {
        event.preventDefault();
        grecaptcha.execute();
    });

    $(document).on('click', '.btn-back', function (event) {
        event.preventDefault();
        $('.confirm-person-tenant').addClass('d-none');
        $('.tenant-person-info').removeClass('d-none');
    });

    $(document).on('click', '.btn-submit-form', function (event) {
        event.preventDefault();
        $('#form-member-person-tenant').submit();
    });

    $(document).on('click', '.btn-update-member-detail', function (event) {
        event.preventDefault();
        MEMBER_TENANT.callAjaxCheckValidationUpdateEnterpriseMember();
    })

    $(document).on('click', '.confirm-person .btn-next-step, .btn-confirm-update-member-detail', function () {
        $('#form-enterprise-member').submit();
    });

    $(document).on('click', '.btn-back-member-detail', function () {
        $('.tenant-person-info').removeClass('d-none');
        $('.confirm-tenant-member-info').addClass('d-none');
    });
});

window.MEMBER_TENANT = MEMBER_TENANT;
